import styled from 'styled-components';

import Color from '../../styles/color';

export const Options = styled.div`
  margin-top: 40px;

  button {
    margin-top: 16px;
  }
`;

export const Content = styled.p`
  font-size: 16px;
  line-height: 22px;
  color: ${Color.neutral90};
  text-align: center;
  margin-top: 16px;
`;
